import { ColDef } from '@ag-grid-community/core';
import { numberValueFormatter2 } from 'src/app/shared/helpers/number-value-formatter';
import { AddEditContractComponent } from '../../components/add-edit-contract/add-edit-contract.component';
import { tooltipRenderer } from 'src/app/shared/helpers/tooltip-renderer';

export const COL_DEFS_SUPPLIER_INVOICES: (
  component: AddEditContractComponent,
) => ColDef[] = (component) => [
  {
    headerName: 'No',
    field: 'id',
    width: 35,
    colId: 'id',
    sortable: false,
    autoHeaderHeight: true,
    floatingFilter: false,
    filter: false,
    editable: false,
    singleClickEdit: true,
    valueFormatter: (params) => {
      const originalValue = params.node?.rowPinned;
      if (originalValue) {
        return '';
      }
      return params.value;
    },
  },
  {
    headerName: 'Date',
    field: 'supplierDate',
    colId: 'supplierDate',
    width: 80,
    autoHeaderHeight: true,
    floatingFilter: false,
    filter: false,
    cellEditor: 'agDateCellEditor',
    editable: true,
    singleClickEdit: true,
    valueFormatter: (params: any) => {
      if (!params.value) {
        return '';
      }
      if (params.value === 'Totals') {
        return params.value;
      }
      const month = params.value.getMonth() + 1;
      const day = params.value.getDate();
      return `${params.value.getFullYear()}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
    },
  },
  {
    headerName: 'b-ETR Supplier Invoices',
    field: 'bEtrSupplierInvoices',
    colId: 'bEtrSupplierInvoices',
    width: 190,
    minWidth: 100,
    autoHeaderHeight: true,
    floatingFilter: false,
    filter: false,
    editable: true,
    singleClickEdit: true,
    flex: 1,
    headerTooltip: 'b-ETR Supplier Invoices',
    cellRenderer: tooltipRenderer,
  },
  {
    headerName: 'Amount',
    field: 'amount',
    colId: 'amount',
    width: 100,
    cellClass: 'ag-right-aligned-cell',
    cellEditor: 'agNumberCellEditor',
    valueFormatter: numberValueFormatter2,
    autoHeaderHeight: true,
    floatingFilter: false,
    filter: false,
    editable: true,
    singleClickEdit: true,
    cellRenderer: tooltipRenderer,
  },
];
